import { render, staticRenderFns } from "./regionalDistribution.vue?vue&type=template&id=8109939c&scoped=true"
import script from "./regionalDistribution.vue?vue&type=script&lang=js"
export * from "./regionalDistribution.vue?vue&type=script&lang=js"
import style0 from "./regionalDistribution.vue?vue&type=style&index=0&id=8109939c&prod&lang=scss"
import style1 from "./regionalDistribution.vue?vue&type=style&index=1&id=8109939c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8109939c",
  null
  
)

export default component.exports